import { AppRouterInstance } from 'next/dist/shared/lib/app-router-context.shared-runtime'
import goToProduct from './goToProduct'
const goToProductVariants = ({
  router,
  product,
  clientConfig,
}: {
  router: AppRouterInstance
  product: any
  clientConfig: any
}) => {
  const { productVariants } = product || {}
  const { variants = [] } = productVariants || {}
  if (clientConfig?.product?.variantsV2?.enabled && variants.length > 0) {
    const productSlug = product.slug
    goToProduct(router, productSlug)
  }
}

export default goToProductVariants
